import getWithToken from './base/get-with-token'

const getSubTenants = getWithToken('/tenants/sub-tenants')

export default getSubTenants